module.exports = __webpack_public_path__ + "img/forte4.e3bc900d.jpeg";